module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-400.woff?49ae34d4cc6b98c00c69ab4c41de3e0c";